import loadingSpinner from './components/loading-spinner'

// Shown while the app is establishing the link to the sensor. The copy depends
// on which link is being tried: over Bluetooth there is nothing for the user
// to do, over Wi-Fi Android is about to ask them to join "Sensor Setup".
export class StepBeforeAttemptToConnect {
  constructor (onboarding) {
    this.onboarding = onboarding;
  }

  id = "before_attempt_to_connect";
  title = "Connecting to Temp Stick";

  template = `
  <div class="onboarding-step" data-for="before_attempt_to_connect">

    <div class="onboarding-connect-phase" data-phase="wifi">
      <p class="onboarding-guide-instruction">
        When prompted, connect to the <b>Sensor Setup</b> WiFi network.
      </p>
      <p class="onboarding-guide-instruction-smaller">
        Your Temp Stick creates this temporary network so that it can connect directly to your device to finish setup.
      </p>
    </div>

    <div class="onboarding-connect-phase" data-phase="ble" style="display: none;">
      <p class="onboarding-guide-instruction text-center">
        Looking for your Temp Stick over <b>Bluetooth</b>...
      </p>
      <p class="onboarding-guide-instruction-smaller text-center">
        Keep the sensor close to this device. If it isn't found we'll connect through its Sensor Setup WiFi network instead.
      </p>
      <div class="onboarding-loading">
        <div class="onboarding-loading__animation">${loadingSpinner()}</div>
      </div>
    </div>

  </div>
  `;

  render = phase => {

    const $phases = $(this.onboarding.container)
      .find('.onboarding-step[data-for="before_attempt_to_connect"] .onboarding-connect-phase');

    $phases.hide();
    $phases.filter(`[data-phase="${phase === 'ble' ? 'ble' : 'wifi'}"]`).show();

  }

  onBack = () => {

  }

  onActivate = () => {
    this.onboarding.hideBackButton();
    this.render(this.onboarding.connect_phase || 'wifi');
  }

  bindActions = () => {

  }

}
